module.exports = "/assets/data/d4b04f547cf0b1f723879fb91dcd975a-B38.data.json";